import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReservation } from '../components/ReservationContext';
import { format, parseISO } from 'date-fns';
import dayjs from 'dayjs';

export default function ConfirmationPage({ setStepNavigationProps }) {
  const location = useLocation();
  const navigate = useNavigate();
    const { clearReservation } = useReservation();

    useEffect(() => {
    // Clear reservation only once when this page is loaded
    clearReservation();
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17225170938/0KzLCM7cufMaEPr_zJVA',
      });
      console.log('Google Ads conversion event fired');
    } else {
      console.warn('gtag not found — check if global script loaded correctly.');
    }
  }, [clearReservation]);

  const reservation = location.state?.reservation;

  if (!reservation) {
    // If reservation state is missing, redirect or show fallback
    return (
      <div className="container py-5 text-center">
        <h2 className="mb-4 text-danger">No reservation found</h2>
        <p>Please return to the home page and try again.</p>
        <button onClick={() => navigate('/')} className="btn btn-dark mt-3">
          Return to Home
        </button>
      </div>
    );
  }

  const { checkIn, checkOut, nights, contact } = reservation;

  return (
    <div className="container py-5 text-center">
      <h2 className="mb-4 text-dark">Your Reservation is Confirmed!</h2>

      <p className="lead">
        Thank you for booking with Dwight Village Motel.
      </p>

      <div className="mt-4 mb-3">
        <p><strong>Check-in Date:</strong>  {checkIn ? dayjs(checkIn).format('MMM D, YYYY') : '-'}</p>
        <p><strong>Check-out Date:</strong>  {checkOut ? dayjs(checkOut).format('MMM D, YYYY') : '-'}</p>
        <p><strong>Total Nights:</strong> {nights}</p>
      </div>

      <p className="text-muted">
        A confirmation email has been sent to <strong>{contact?.email || 'your email address'}</strong>.
        Please check your inbox for the full reservation details.
      </p>

      <div className="mt-4">
        <a href="https://dwightvillagemotel.com" className="btn btn-dark">Return to Dwight Village Motel</a>
      </div>
    </div>
  );
}
